import { Tbody as ChakraTbody } from '@chakra-ui/react'

export const Tbody = ({ children, ...props }) => <ChakraTbody {...props}>{children}</ChakraTbody>
